
import { isObject } from 'lodash-es';
import React, { useRef, useEffect } from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const Image = ({ src, alt, className, style, svg, select, setSelected  }) => {
  let base = process.env.REACT_APP_BASE_URL
  let SRC = `${base}${src}`
  const svgRef = useRef()
  useEffect(() => {
    if (svg) toSvg(`${process.env.REACT_APP_BASE_URL}${src}`)
  }, [SRC]);  

  const toSvg = async (img) => {
    const imageUrl = img;
    // Create new XML Http Request to get data
    let request = new XMLHttpRequest();
    request.open('GET', imageUrl, true);
    request.onreadystatechange = await function () {
      if (this.readyState === 4) {
        if ((this.status >= 200) && (this.status < 400)) {
          let req = request.responseXML.getElementsByTagName('svg')[0];
          var title = document.createElement("title")
          title.text = alt
          req.prepend(title)
          req.setAttribute("class", "icon")
          req.title = alt
          // if (svgRef.current) {
          //   for(let child of req.children[1].children){
          //     let name = child.getAttribute("name")
          //     child.style.fill = select[name]? 'rgba(255, 181, 162, 1)':null
          //   }
            svgRef.current.replaceWith(req)

          // }
        } else {
          // Error :(
        }
      }
    };
    request.send(null);
    // if(select){
    //   document.addEventListener('click', function (event) {
    //     console.log(select)
    //     let name = event.target.getAttribute("name")
    //     let obj={...select}
        
    //     if(select[name]){
    //       delete select[name]
    //     }else{
    //       select[name] = true
    //     }
    //     console.log(obj)
    //     setSelected(obj)

    //   }, false);
    // }
    

  }
  return (
    <>
    {
      svg?(<figure className='icon' 
      ref={svgRef} 
      style={{width:"100%"}}

      />):(<figure className={className} style={style}>
        {/* <img loading="lazy"
          /> */}
        <LazyLoadImage 
          alt={alt ? alt : ''}
          // effect="blur"
          delayTime={3000}
          visibleByDefault={false}
          fetchpriority="false"
          src={SRC}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
      </figure>)
    }
    </>
  )
}

export default Image